import * as React from "react";
import { useTranslation } from "react-i18next";
import { DocumentTitle } from "components/common";
import { getEnterpriseGroupSyncPlugin } from "util/AuthenticationService";
import WizardPageHeader from "./WizardPageHeader";
import BackendWizard from "../BackendWizard";
import HelpText from "../HelpText";
import handleCreate from "../HandleCreate";
export const HELP = {
  // server config help
  systemUserDn: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "active_directory.help.system_user_dn" }),
  systemUserPassword: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "active_directory.help.system_user_password" }),
  // user sync help
  userSearchBase: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "active_directory.help.user_search_base" }),
  userSearchPattern: /* @__PURE__ */ React.createElement(
    HelpText,
    {
      i18nKey: "directory_help.user_search_pattern",
      values: { example: "(&(objectClass=user)(|(sAMAccountName={0})(userPrincipalName={0})))", placeholder: "{0}" }
    }
  ),
  userNameAttribute: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "active_directory.help.user_name_attribute" }),
  userFullNameAttribute: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "active_directory.help.user_full_name_attribute" }),
  defaultRoles: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "directory_help.default_roles" }),
  defaultUserTimezone: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "directory_help.default_user_timezone" })
};
export const AUTH_BACKEND_META = {
  serviceTitle: "Active Directory",
  serviceType: "active-directory"
};
const INITIAL_VALUES = {
  title: AUTH_BACKEND_META.serviceTitle,
  serverHost: "localhost",
  serverPort: 636,
  transportSecurity: "tls",
  userSearchPattern: "(&(objectClass=user)(|(sAMAccountName={0})(userPrincipalName={0})))",
  userFullNameAttribute: "displayName",
  userNameAttribute: "userPrincipalName",
  verifyCertificates: true
};
const BackendCreate = () => {
  var _a, _b;
  const { t } = useTranslation("authentication");
  const enterpriseGroupSyncPlugin = getEnterpriseGroupSyncPlugin();
  const {
    help: groupSyncHelp = {},
    excludedFields: groupSyncExcludedFields = {},
    initialValues: initialGroupSyncValues
  } = (_b = (_a = enterpriseGroupSyncPlugin == null ? void 0 : enterpriseGroupSyncPlugin.wizardConfig) == null ? void 0 : _a.activeDirectory) != null ? _b : {};
  const help = { ...HELP, ...groupSyncHelp };
  const initialValues = { ...INITIAL_VALUES, ...initialGroupSyncValues };
  const excludedFields = { ...groupSyncExcludedFields, userUniqueIdAttribute: true, emailAttributes: true };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("active_directory.create_title") }, /* @__PURE__ */ React.createElement(WizardPageHeader, null), /* @__PURE__ */ React.createElement(
    BackendWizard,
    {
      authBackendMeta: AUTH_BACKEND_META,
      help,
      excludedFields,
      initialValues,
      onSubmit: handleCreate
    }
  ));
};
export default BackendCreate;
